import {DomainEvent} from './DomainEvent';
import {CupTeamSeason} from '../resources/CupTeamSeason';

export class CupTeamSeasonCreated extends DomainEvent<CupTeamSeason> {}
